export default __webpack_public_path__ + "roboto-v27-latin-700.b018b3.ttf";